import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { toast } from "sonner";

const STATI = [
  { v: "nuova", l: "Nuova" },
  { v: "vista", l: "Vista" },
  { v: "contattato", l: "Contattato" },
  { v: "documentazione_inviata", l: "Doc. inviata" },
  { v: "in_trattativa", l: "In trattativa" },
  { v: "chiusa_positiva", l: "Chiusa +" },
  { v: "chiusa_negativa", l: "Chiusa −" },
];

const fmtDT = (iso) => iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";

export default function AgenziaDocumentazione() {
  const [items, setItems] = useState([]);
  const [expanded, setExpanded] = useState(null);
  const [noteDraft, setNoteDraft] = useState("");

  const load = () => api.get("/agency/document-requests").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const setStato = async (id, v) => {
    try { await api.patch(`/agency/document-requests/${id}`, { status: v }); load(); toast.success("Stato aggiornato"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const saveNote = async (id) => {
    try { await api.patch(`/agency/document-requests/${id}`, { note_agenzia: noteDraft }); setExpanded(null); load(); toast.success("Nota salvata"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div data-testid="agenzia-documentazione">
      <div className="label-uppercase">La mia agenzia</div>
      <h1 className="font-serif text-4xl mt-2 mb-8">Richieste documentazione</h1>

      <table className="admin-table w-full bg-white border border-[#E6E4E0]">
        <thead><tr><th>Tipo</th><th>Richiedente</th><th>Immobile</th><th>Ricevuta</th><th>Stato</th><th></th></tr></thead>
        <tbody>
          {items.map((d) => (
            <React.Fragment key={d.id}>
              <tr data-testid={`agency-docreq-row-${d.id}`}>
                <td>
                  <span className={`badge-stamp text-[10px] ${d.tipo === "contatto_agenzia" ? "badge-pronto" : "badge-criticita"}`}>
                    {d.tipo === "contatto_agenzia" ? "Contatto" : "Richiesta doc."}
                  </span>
                </td>
                <td><div className="font-medium">{d.nome}</div><div className="text-xs text-[#5C5657]">{d.email} · {d.telefono}</div></td>
                <td className="text-xs">{d.property_titolo || "—"}</td>
                <td className="text-xs whitespace-nowrap">{fmtDT(d.created_at)}</td>
                <td>
                  <select data-testid={`agency-docreq-status-${d.id}`} value={d.status} onChange={(e) => setStato(d.id, e.target.value)} className="text-xs border border-[#E6E4E0] px-2 py-1 bg-white">
                    {STATI.map((s) => <option key={s.v} value={s.v}>{s.l}</option>)}
                  </select>
                </td>
                <td className="text-right"><button onClick={() => { if (expanded === d.id) { setExpanded(null); } else { setExpanded(d.id); setNoteDraft(d.note_agenzia || ""); } }} className="text-xs label-uppercase text-[#7D2E3F]">{expanded === d.id ? "Chiudi" : "Note"}</button></td>
              </tr>
              {expanded === d.id && (
                <tr><td colSpan="6" className="bg-[#FDFDFC]">
                  <div className="p-4">
                    {d.messaggio && <div className="mb-3"><div className="label-uppercase text-[#5C5657] mb-1">Messaggio</div><div className="text-sm">{d.messaggio}</div></div>}
                    <div className="label-uppercase text-[#5C5657] mb-1">Note interne</div>
                    <textarea rows="3" value={noteDraft} onChange={(e) => setNoteDraft(e.target.value)} className="admin-input" />
                    <div className="text-right mt-2"><button onClick={() => saveNote(d.id)} className="btn-primary text-xs">Salva nota</button></div>
                  </div>
                </td></tr>
              )}
            </React.Fragment>
          ))}
          {items.length === 0 && <tr><td colSpan="6" className="text-center py-8 text-[#5C5657]">Nessuna richiesta al momento</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
